import React from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { Icon } from "./Icon";
import { AttainmentRisk } from "../../constants/interfaces";
import classNames from "../../utils/classNames";

type Props = {
  classes?: any;
  risk: AttainmentRisk;
};

type State = {};

const styles = (theme: Theme) =>
  createStyles({
    riskCell: {
      alignItems: "center",
      display: "flex",
      textTransform: "capitalize"
    },
    riskIcon: {
      marginRight: theme.spacing(1) / 2
    },
    criticalRiskCell: {
      color: theme.palette.error.main
    },
    highRiskCell: {
      color: theme.palette.secondary.main
    }
  });

class AttainmentRiskIcon extends React.Component<Props, State> {
  render() {
    const { risk, classes } = this.props;
    switch (risk) {
      case AttainmentRisk.UA_CRITICAL: // ...same as case below
      case AttainmentRisk.PA_CRITICAL: {
        return (
          <span
            className={classNames(classes.riskCell, classes.criticalRiskCell)}
          >
            <Icon className={classes.riskIcon} name="error" />
            Critical
          </span>
        );
      }
      case AttainmentRisk.UA_HIGH: // ...same as case below
      case AttainmentRisk.PA_HIGH: {
        return (
          <span className={classNames(classes.riskCell, classes.highRiskCell)}>
            <Icon className={classes.riskIcon} name="warning" />
            High
          </span>
        );
      }
      case AttainmentRisk.UA_MODERATE: // ...same as case below
      case AttainmentRisk.PA_MODERATE: {
        return <span className={classes.riskCell}>Moderate</span>;
      }
      case AttainmentRisk.UA_LOW: // ...same as case below
      case AttainmentRisk.PA_LOW: {
        return <span className={classes.riskCell}>Low</span>;
      }
      case AttainmentRisk.UA_NEGLIGIBLE: // ...same as case below
      case AttainmentRisk.PA_NEGLIGIBLE: {
        return <span className={classes.riskCell}>Negligible</span>;
      }
      default: {
        return <span className={classes.riskCell}>{risk}</span>;
      }
    }
  }
}

const styled = withStyles(styles)(AttainmentRiskIcon);
export { styled as AttainmentRiskIcon };
